import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_infoStaffCheck = _resolveComponent("infoStaffCheck")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_searchComponent = _resolveComponent("searchComponent")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_tableComponent = _resolveComponent("tableComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      default: _withCtx(() => [
        _createVNode(_component_infoStaffCheck, { "info-data": _ctx.infoData }, null, 8, ["info-data"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      class: "container mg-t-20"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_searchComponent, {
          "search-list": _ctx.searchList,
          "onUpdate:searchList": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchList) = $event)),
          "button-list": _ctx.buttonList,
          onDoSearch: _ctx.handleSearch
        }, null, 8, ["search-list", "button-list", "onDoSearch"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_tableComponent, {
            class: "mg-t-10",
            "table-data": _ctx.tableData,
            "table-head": _ctx.tableHead,
            onSelectionChange: _ctx.handleSelectionChange,
            "page-info": _ctx.pageInfo,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange
          }, {
            operate: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_button, {
                  type: "text",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (_ctx.handleArchive(scope.row)), ["stop"])
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("查看详情")
                  ])),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["table-data", "table-head", "onSelectionChange", "page-info", "onSizeChange", "onCurrentChange"])
        ])
      ]),
      _: 1
    })
  ], 64))
}